import { common } from '../common.js';
import type { IProgram } from '../types.js';

/** Open work permit in Canada for a sponsored spouse or partner (or their dependent child), once the PR application has an AOR. */
export const SPOUSE_OPEN_WORK_PERMIT: IProgram = {
  id: 'spouse-open-work-permit',
  name: 'Open work permit for a sponsored spouse or partner (in Canada)',
  short: 'Spousal open work permit',
  family: 'temporary',
  status: 'active',
  maintainedStatus: true,
  version: '2026-10-03',
  review: 'pending',
  sources: [
    { title: 'IRCC: Optional, open work permit in Canada (spouse, partner or child being sponsored)', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/family-sponsorship/spouse-partner-children/spouse-common-law-partner-canada-open-work-permit.html', retrieved: '2026-10-03' }
  ],
  questions: [
    { id: 'validStatus', text: 'Does the applicant have valid temporary resident status in Canada?', kind: 'yesno' },
    { id: 'hasAor', text: 'Has the sponsorship received its acknowledgement of receipt (AOR)?', kind: 'yesno' }
  ],
  roles: [
    { id: 'principal', label: 'Applicant (person being sponsored)', min: 1, max: 1 },
    { id: 'dependant', label: 'Accompanying dependent child', min: 0, max: 15 }
  ],
  sections: ['Forms', 'Eligibility', 'Identity and civil documents', 'Photos and police certificates', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC personalized document checklist (from the IRCC secure account or APR portal)', section: 'Forms', forRoles: 'application', source: 0, hint: 'Answer the questions to get it; it lists most documents to upload.' },
    common.representative(0),
    { id: 'aor', label: 'Acknowledgement of receipt (AOR) for the permanent residence application', section: 'Eligibility', forRoles: 'application', source: 0, hint: 'The AOR the sponsor received; the application number starts with F.' },
    { id: 'noAorExpiry', label: 'Proof the current permit or status expires in 2 weeks or less (applying without an AOR)', section: 'Eligibility', forRoles: 'application', when: { q: 'hasAor', is: false }, source: 0 },
    { id: 'livingTogether', label: 'Proof of living in Canada with the sponsor', section: 'Eligibility', forRoles: 'application', source: 0 },
    { id: 'status', label: 'Proof of valid temporary resident status (visitor record, permit, or restoration application)', section: 'Eligibility', forRoles: ['principal', 'dependant'], when: { q: 'validStatus', is: true }, source: 0 },
    common.passport(0, ['principal', 'dependant']),
    common.fees(0)
  ],
  deadlines: []
};
